import React from 'react';

const AboutPage = () => {
  return (
    <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh' }}>
      {/* PAGE_ABOUT: Product information and use cases */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '48px 24px' 
      }}>
        <h1 style={{
          fontSize: '35px',
          lineHeight: '1.03',
          fontWeight: 600,
          color: '#000000', // Pure black for heading
          letterSpacing: '-0.02em',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          margin: '0 0 32px 0'
        }}>
          About Tabby Website Checker
        </h1>
        
        <div style={{ marginBottom: '48px' }}>
          <p style={{
            fontSize: '16px',
            color: '#6B7785', // Tabby secondary text color
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            lineHeight: '1.5',
            margin: '0 0 24px 0'
          }}>
            The Tabby Website Checker is a powerful tool designed to instantly detect whether any online merchant accepts Tabby's flexible payment solutions. Our comprehensive analysis helps both businesses and consumers make informed decisions about payment options.
          </p>
          
          <p style={{
            fontSize: '16px',
            color: '#6B7785',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            lineHeight: '1.5',
            margin: '0'
          }}>
            Using advanced detection algorithms, we analyze multiple page types including homepages, product pages, and checkout flows to provide accurate, real-time results with visual proof of Tabby integration.
          </p>
        </div>

        {/* Key Features */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '22px',
            lineHeight: '1.09',
            fontWeight: 600,
            color: '#000000',
            letterSpacing: '-0.01em',
            margin: '0 0 24px 0',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
          }}>
            Key Features
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth >= 768 ? '1fr 1fr' : '1fr', gap: '24px' }}>
            <div style={{ padding: '24px 0' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1A202C',
                margin: '0 0 12px 0'
              }}>
                ⚡ Instant Detection
              </h3>
              <p style={{ color: '#6B7785', fontSize: '14px', lineHeight: '1.5', margin: '0' }}>
                Get results in under 3 seconds with our optimized detection engine that analyzes multiple page types simultaneously.
              </p>
            </div>
            
            <div style={{ padding: '24px 0' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1A202C',
                margin: '0 0 12px 0'
              }}>
                🎯 High Accuracy
              </h3>
              <p style={{ color: '#6B7785', fontSize: '14px', lineHeight: '1.5', margin: '0' }}>
                90%+ detection accuracy with comprehensive analysis including visual proof and detailed evidence.
              </p>
            </div>
            
            <div style={{ padding: '24px 0' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1A202C',
                margin: '0 0 12px 0'
              }}>
                📊 Multi-Page Analysis
              </h3>
              <p style={{ color: '#6B7785', fontSize: '14px', lineHeight: '1.5', margin: '0' }}>
                Analyzes up to 12 pages including product pages, checkout flows, and payment sections for comprehensive coverage.
              </p>
            </div>
            
            <div style={{ padding: '24px 0' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1A202C',
                margin: '0 0 12px 0'
              }}>
                🔍 Detailed Evidence
              </h3>
              <p style={{ color: '#6B7785', fontSize: '14px', lineHeight: '1.5', margin: '0' }}>
                Provides specific evidence and locations where Tabby integration was found, with confidence ratings.
              </p>
            </div>
          </div>
        </section>

        {/* Target Users */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '22px',
            lineHeight: '1.09',
            fontWeight: 600,
            color: '#000000',
            letterSpacing: '-0.01em',
            margin: '0 0 24px 0',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
          }}>
            Who It's For
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth >= 768 ? '1fr 1fr' : '1fr', gap: '32px' }}>
            <div>
              <h3 style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1A202C',
                margin: '0 0 12px 0'
              }}>
                🏪 E-commerce Managers
              </h3>
              <p style={{ color: '#6B7785', fontSize: '14px', lineHeight: '1.5', margin: '0' }}>
                Research competitors' payment options, identify market opportunities, and make informed decisions about payment integration strategies.
              </p>
            </div>
            
            <div>
              <h3 style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1A202C',
                margin: '0 0 12px 0'
              }}>
                🛍️ Smart Shoppers
              </h3>
              <p style={{ color: '#6B7785', fontSize: '14px', lineHeight: '1.5', margin: '0' }}>
                Find retailers that accept Tabby's flexible payment options before you shop, enabling better financial planning.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
